import { render, staticRenderFns } from "./CorteGlobalTienda.vue?vue&type=template&id=aa56fc68&"
import script from "./CorteGlobalTienda.vue?vue&type=script&lang=js&"
export * from "./CorteGlobalTienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports